import { render, staticRenderFns } from "./SkillsInventoryChart.vue?vue&type=template&id=5a27ef5e&scoped=true&"
import script from "./SkillsInventoryChart.vue?vue&type=script&lang=js&"
export * from "./SkillsInventoryChart.vue?vue&type=script&lang=js&"
import style0 from "./SkillsInventoryChart.vue?vue&type=style&index=0&id=5a27ef5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27ef5e",
  null
  
)

export default component.exports